import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: [],
    selection: {},
    show: false,
    status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("holidaysDashboard/fetchCount", async (amount) => {
    // The value we return becomes the `fulfilled` action payload
});

export const holidaysDashboardSlice = createSlice({
    name: "holidaysDashboard",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addToShowHolidaysDashboardData: (state, action) => {
            state.show = action.payload;
        },
        addToSelectionHolidaysDashboard: (state, action) => {
            state.selection = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { addToShowHolidaysDashboardData, addToSelectionHolidaysDashboard } =
    holidaysDashboardSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.holidaysDashboard.value)`
export const selectHolidaysDashboard = (state) => state.holidaysDashboard.value;
export const selectShowHolidaysDashboard = (state) => state.holidaysDashboard.show;
export const selectSelectionHolidaysDashboard = (state) => state.holidaysDashboard.selection;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const handleShowHolidaysDashboardOverlay = () => (dispatch, getState) => {
    const currentValue = selectShowHolidaysDashboard(getState());
    if (currentValue) {
        document.body.style.overflowY = "";
    } else {
        document.body.style.overflowY = "hidden";
    }
    dispatch(addToShowHolidaysDashboardData(!currentValue));
};
export default holidaysDashboardSlice.reducer;
